// extracted by mini-css-extract-plugin
export default {"cls1":"_Abm4A5ivi5CBooYKAXg","cls2":"jvGPFxVjZ40blPKWlcL7 _Abm4A5ivi5CBooYKAXg","isLargeScreen":"sLxXyOJDkUkmEkNEGSdn"};